import styled from '@emotion/styled';

const TableFooter = styled.div``;

export { TableFooter };
